<template>
  <div>
    <!-- Seletor de quantidade de itens por página -->
    <div class="mb-3 text-center">
      <label for="rowsPerPage" class="form-label me-2">Itens por página:</label>
      <select
        id="rowsPerPage"
        class="form-select d-inline-block w-auto"
        v-model="itemsPerPage"
        @change="changeRowsPerPage"
      >
        <option
          v-for="option in rowsPerPageOptions"
          :key="option"
          :value="option"
        >
          {{ option === -1 ? "Todos" : option }}
        </option>
      </select>
    </div>

    <!-- Paginação -->
    <ul class="mt-3 pagination justify-content-center pagination-no-border">
      <!-- Botão Anterior -->
      <li class="page-item prev-page" :class="{ disabled: currentPage === 1 }">
        <a
          class="page-link"
          aria-label="Previous"
          @click="changePage(currentPage - 1)"
        >
          <i class="tim-icons icon-double-left" aria-hidden="true"></i>
        </a>
      </li>

      <!-- Botões numerados para cada página -->
      <li
        class="page-item"
        v-for="page in totalPagesArray"
        :key="page"
        :class="{ active: currentPage === page }"
      >
        <a class="page-link" @click="changePage(page)">
          {{ page }}
        </a>
      </li>

      <!-- Botão Próximo -->
      <li
        class="page-item next-page"
        :class="{ disabled: currentPage === totalPages }"
      >
        <a
          class="page-link"
          aria-label="Next"
          @click="changePage(currentPage + 1)"
        >
          <i class="tim-icons icon-double-right" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PaginacaoComQuantidade",
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    rowsPerPage: {
      type: Number,
      default: 100 // Valor padrão
    },
    rowsPerPageOptions: {
      type: Array,
      default: () => [100, 200, 400, -1] // Opções padrão
    }
  },
  data() {
    return {
      itemsPerPage: 100 // Quantidade padrão de itens por página
    };
  },
  computed: {
    totalPages() {
      return this.rowsPerPage === -1
        ? 1 // Apenas uma página para "Todos"
        : Math.ceil(this.totalItems / this.rowsPerPage);
    },
    totalPagesArray() {
      return Array.from({ length: this.totalPages }, (v, i) => i + 1);
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit("page-changed", page);
        this.scrollToTop();
      }
    },
    changeRowsPerPage() {
      this.$emit("rows-per-page-changed", this.itemsPerPage);
      // Resetar para a primeira página ao mudar a quantidade de itens por página
      this.changePage(1);
    },
    scrollToTop() {
      if (this.scrollTarget) {
        const targetElement = document.querySelector(this.scrollTarget);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }
};
</script>

<style scoped></style>
